module.exports = __webpack_public_path__ + "files/sharepoint-2010-application-development.e287c45e.pdf";